import { Routes, Route } from "react-router-dom";
import { PasswordsList } from "@/pages/Passwords/PasswordsList";

export function PasswordsRoutes() {
    return (
        <Routes>
            <Route path="/" element={<PasswordsList />} />
            <Route path="/:tab" element={<PasswordsList />} />
            <Route path="/:tab/:groupId" element={<PasswordsList />} />
        </Routes>
    );
}
